import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('AppUser')

export default {
  label: 'AppUser',
  route: 'appuser',
  fields: [
    // Filter.Reference(
    //   'organisationseinheit',
    //   'sitemap',
    //   'organisationseinheit',
    //   {
    //     name: 'bySearchRepLikeUnrestricted',
    //     multiValue: false,
    //     minLength: 0
    //   }
    // ),
    Filter.String('userName'),
    Filter.String('email'),
    Filter.ReferenceBySearchRep(
      'applicationRoles',
      'user-secret',
      'appRole'
    ),
    Filter.ReferenceBySearchRep(
      'organisationseinheiten',
      'sitemap',
      'organisationseinheit'
    ),
    Filter.ReferenceBySearchRep(
      'zstzlOrganisationseinheiten',
      'sitemap',
      'organisationseinheit'
    )
    // Filter.String('verleihungsJahr')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/AppUserFilter.js